import { useI18n } from 'vue-i18n'

/** 模块 i18n 工厂：`{domain}.{section?}.{key}` */
export function createModuleI18n(domain: string, section?: string) {
  const { t } = useI18n()
  const prefix = section ? `${domain}.${section}` : domain
  const tv = (key: string, params?: Record<string, unknown>) =>
    t(`${prefix}.${key}`, params ?? {})
  return { t, tv, prefix }
}
